import { render, staticRenderFns } from "./NotificationSubscription.vue?vue&type=template&id=6b417a36"
import script from "./NotificationSubscription.vue?vue&type=script&lang=ts"
export * from "./NotificationSubscription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports